import { useMutation, useQueryClient } from '@tanstack/react-query';
import { subscribe } from '@/services/subscription.service';
import { queryKeys } from '@/hooks/queries/keys';
import type { SubscribeReq, SubscriptionDto } from '@/types/subscription';

export const useSubscribe = () => {
    const queryClient = useQueryClient();
    return useMutation<SubscriptionDto, unknown, SubscribeReq>({
        mutationFn: subscribe,
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.me() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.snapshot() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.payments() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.usage() });
            queryClient.invalidateQueries({ queryKey: queryKeys.subscription.changeHistory() });
        },
    });
};
